import request from '@/utils/request'

/// /////////////////////////////////////////////////////////////////////////////
/// //////////////////////////文章///////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////
// 文章列表
export function getArticleList () {
  return request({
    url: '/public/articleList',
    method: 'POST'
  })
}

// 文章信息
export function getArticleInfo (articleId, sign) {
  return request({
    url: '/public/articleInfo',
    method: 'POST',
    params: { articleId, sign }
  })
}
/// /////////////////////////////////////////////////////////////////////////////
/// //////////////////////////用户///////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////
// 修改密码
export function forgetPwd (data) {
  return request({
    url: '/public/forgetPwd',
    method: 'POST',
    data
  })
}
/// /////////////////////////////////////////////////////////////////////////////
/// //////////////////////////公共属性///////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////
// 公共属性
export function getCommonParam (identity) {
  return request({
    url: '/public/commonParam',
    method: 'POST',
    params: { identity }
  })
}



// WEBPACK FOOTER //
// ./src/api/public.js